<template>
  <Dialog
    header="Add Items to request"
    v-model:visible="Editmodel"
    :breakpoints="{ '960px': '40vw', '641px': '60vw', '500px': '80vw' }"
    :style="{ width: '30vw' }"
    :modal="true"
    :closable="false"
  >
    <p>{{ msgcontent.contentvalue }}</p>
    <template #footer>
      <AddButton btnname="Yes" @click="$emit('yes')" />
      <AddButton btnname="No" @click="$emit('no')" />
    </template>
  </Dialog>
</template>
<script lang="ts">
import { reactive } from "vue";
import { defineComponent, ref, watch } from "vue";
export default defineComponent({
  props: {
    Editmodel: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const msgcontent = reactive({
      contentvalue: "",
    });
    watch(props, (newValue) => {
      Object.assign(msgcontent, newValue.content);
    });

    return {
      msgcontent,
    };
  },

  methods: {},
});
</script>
